import * as site from "./site";
import { WEB_PACKAGES } from "./pricing";
import { SERVICES } from "./services";
import { HOME_FAQS } from "./home";

export const HOME_TEXT = {
  hero_chip: "Il tuo sito professionale da <strong>490 € + 39 €/mese</strong>",
  hero_title: "Il tuo business merita un sito che",
  hero_highlight: "si faccia notare.",
  hero_subtitle: "Creiamo e gestiamo siti web professionali per negozi, professionisti e imprese. Prezzi chiari, qualità premium e zero complicazioni. In tutta Italia.",
  hero_cta_primary: "Scopri i nostri siti",
  hero_cta_secondary: "Guarda i prezzi",
  hero_bullets: ["IVA esclusa, tutto scritto", "Hosting e manutenzione inclusi", "Consulenza online gratuita"],
  pricing_title: "Scegli il tuo sito.",
  pricing_highlight: "Il prezzo lo sai già.",
  pricing_subtitle: "IVA esclusa. Nessun costo nascosto.",
  preview_title: "Guarda come potrebbe diventare",
  preview_highlight: "il sito della tua attività.",
  preview_text: "Scopri la qualità dei nostri progetti e richiedi una proposta grafica personalizzata per il tuo business.",
  preview_cta: "Richiedi un’anteprima",
};

export const SECTION_LABELS = {
  hero: "Hero iniziale", promo: "Promozioni attive", portfolio: "Carosello portfolio", pricing: "Pacchetti e prezzi",
  services: "Servizi (bento)", why: "Perché noi + 5 passi", preview: "Richiedi un’anteprima", faq: "FAQ + modulo contatti",
};
export const HOME_SECTIONS = Object.keys(SECTION_LABELS).map((id) => ({ id, enabled: true }));

const PKG_KEYS = ["setup", "monthly", "tagline", "headline", "highlights", "features", "note", "featured", "badge"];
const SRV_KEYS = ["name", "short", "h1", "intro", "description"];
const clone = (x) => JSON.parse(JSON.stringify(x));
const pick = (o, keys) => Object.fromEntries(keys.map((k) => [k, o[k] ?? (k === "badge" ? "Consigliato" : k === "featured" ? false : "")]));

export const DEFAULTS = clone({
  contact: { phone: site.PHONE, email: site.EMAIL, whatsapp: site.WA_NUMBER },
  home: HOME_TEXT,
  sections: HOME_SECTIONS,
  packages: WEB_PACKAGES.map((p) => ({ id: p.id, name: p.name, ...pick(p, PKG_KEYS) })),
  services: SERVICES.map((s) => ({ slug: s.slug, ...pick(s, SRV_KEYS) })),
  faqs: HOME_FAQS,
});

const replace = (arr, items) => arr.splice(0, arr.length, ...items);

export function mergeSections(saved) {
  const list = (saved || []).filter((s) => SECTION_LABELS[s.id]);
  DEFAULTS.sections.forEach((d) => { if (!list.find((s) => s.id === d.id)) list.push(d); });
  return list.map((s) => ({ id: s.id, enabled: s.enabled !== false }));
}

export function applyContent(data = {}) {
  site.setContact({ ...DEFAULTS.contact, ...(data.contact || {}) });
  Object.assign(HOME_TEXT, clone(DEFAULTS.home), data.home || {});
  replace(HOME_SECTIONS, mergeSections(data.sections));
  WEB_PACKAGES.forEach((p) => {
    const d = DEFAULTS.packages.find((x) => x.id === p.id);
    const o = (data.packages || []).find((x) => x.id === p.id) || {};
    PKG_KEYS.forEach((k) => { p[k] = o[k] ?? d[k]; });
  });
  SERVICES.forEach((s) => {
    const d = DEFAULTS.services.find((x) => x.slug === s.slug);
    const o = (data.services || []).find((x) => x.slug === s.slug) || {};
    SRV_KEYS.forEach((k) => { s[k] = o[k] || d[k]; });
  });
  replace(HOME_FAQS, data.faqs?.length ? data.faqs : clone(DEFAULTS.faqs));
}

export function currentContent(data = {}) {
  return {
    contact: { ...DEFAULTS.contact, ...(data.contact || {}) },
    home: { ...DEFAULTS.home, ...(data.home || {}) },
    sections: mergeSections(data.sections),
    packages: DEFAULTS.packages.map((d) => ({ ...d, ...((data.packages || []).find((x) => x.id === d.id) || {}) })),
    services: DEFAULTS.services.map((d) => ({ ...d, ...((data.services || []).find((x) => x.slug === d.slug) || {}) })),
    faqs: clone(data.faqs?.length ? data.faqs : DEFAULTS.faqs),
  };
}
